import { connect } from 'react-redux';

import { isGuidedTourOpened } from '../../modules/GuidedTour/service/GuidedTour.selector';
import { Home } from './Home';

export const mapStateToProps = (state: any) => {
	return {
		isGuidedTourOpened: isGuidedTourOpened(state),
	};
};

export const ConnectedHome = connect(mapStateToProps)(Home);
